<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import jwtDecode from 'jwt-decode'
  export default {
    name: 'App',
    mounted () {
      const isWidget = this.$route.path.startsWith('/widgets/')
      const hubspotCode = process.env.HUBSPOT_CODE

      let hubspotScript = document.createElement('script')
      hubspotScript.setAttribute('src', `//js.hs-scripts.com/${hubspotCode}.js`)
      hubspotScript.setAttribute('id', 'hs-script-loader')
      hubspotScript.setAttribute('defer', '')
      document.head.appendChild(hubspotScript)

      if (!isWidget) {
        let appCues = document.createElement('script')
        appCues.setAttribute('src', process.env.APP_CUES_URL)
        document.head.appendChild(appCues)

        let innerTrends = document.createElement('script')
        innerTrends.innerHTML = `
          (function(w,o,d,s) {
            w['_itlk']='23cbf41b117ea1ae834937a-2';
            w['_itlt']=[]; w['_itlq']=[];w['_itld']=s;w[o]=w[o]||{log:function(t,v,p){w['_itlt'].push([t,v,p])},stream:function(q){w['_itlq'].push([q])}};
            var pa = d.createElement('script'), ae = d.getElementsByTagName('script')[0], protocol = (('https:' == d.location.protocol) ? 'https://' : 'http://');pa.async = 1;  pa.src = protocol + 'io.innertrends.com/itl.js'; pa.type = 'text/javascript'; ae.parentNode.insertBefore(pa, ae);
          })(window,'_itl',document,"");`
        document.body.appendChild(innerTrends)

        let intercomScript = document.createElement('script')
        intercomScript.innerHTML = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${process.env.INTERCOM_ID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
        document.body.appendChild(intercomScript)

        let isLoggedIn = () => {
          const loggedIn = !!localStorage.auth_token
          const expiredToken = (token) => {
            if (token === null) {
              return true
            }
            let decodedToken = jwtDecode(token)
            let now = Date.now() / 1000
            return decodedToken.exp < Number(now.toFixed(0))
          }
          const authToken = (typeof localStorage.auth_token !== 'undefined' && localStorage.auth_token !== null) ? localStorage.auth_token : null
          return loggedIn && !expiredToken(authToken)
        }

        if (isLoggedIn()) {
          const email = localStorage.getItem('email')
          const firstName = localStorage.getItem('first_name')
          const lastName = localStorage.getItem('last_name')
          const fullName = `${firstName} ${lastName}`.trim()
          const createdAt = localStorage.getItem('org_join_date')
          const userHash = localStorage.getItem('user_hash')
          window.Intercom('boot', {
            app_id: process.env.INTERCOM_ID,
            name: `${fullName}`,
            email: `${email}`,
            user_hash: userHash,
            created_at: createdAt
          })
        } else {
          window.Intercom('shutdown')
        }
      }
    }
  }
</script>
<style>
    .no-shadow {
        box-shadow: none !important;
    }

    .transparent-table tr:hover {
        background-color: transparent !important;
    }

    .row{
        margin-bottom: 12px;
    }
    .row:last-child{
        margin-bottom: 0;
    }
    .row > .col{
        width: 100%;
    }
    .row > .col > div{
        width: 100%
    }
    @media screen and (min-width: 768px){
        .row{
            max-width: 1100px
        }
        .row > .col{
            width: 33%;
            padding-right: 5px;
            box-sizing: border-box;
        }
        .row > .col:last-child{
            width: 34%;
            padding-right: 0
        }
        .row > .col > div:first-child{
            width: 120px;
            margin-right: 5px;
        }
        .row > .col > div:last-child{
            width: calc(100% - 125px);
            word-break: break-word;
        }
    }

    .f12 {
      font-size: 12px
    }

    .f14 {
      font-size: 14px
    }

    .is-size-10pt {
        font-size: 10pt;
    }
    .button-dropdown {
        justify-content: left;
        min-width: 100%;
        color: #8A8C91 !important;
        background-color: #fff !important;
        border-color: #dbdbdb !important;
        min-height: 39px !important;
    }

    .input {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        color: #8a8c91;
    }

    @media screen and (max-width: 768px) {
        body {
            overflow-x: hidden;
            font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
        }

        input[type=checkbox]:checked {
          background-color: #31AAE1 !important;
        }
    }

    @media screen and (max-width: 1024px) {
        body {
            overflow-x: hidden;
            font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
        }
    }

    body, button, input, select, textarea, * {
        font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    }

    .margin-right-10 {
        margin-right: 10px !important;
    }

    .margin-right-30 {
        margin-right: 30px;
    }

    .margin-right-20 {
        margin-right: 20px;
    }

    .margin-top-8 {
      margin-top: 8px;
    }

    .margin-top-10 {
        margin-top: 10px;
    }

    .margin-top-20 {
        margin-top: 20px;
    }

    .margin-top-30 {
        margin-top: 30px;
    }

    .margin-top-40 {
        margin-top: 40px;
    }

    .margin-top-70 {
      margin-top: 70px;
    }

    .margin-top-4 {
        margin-top: 4px;
    }

    .margin-top-25 {
        margin-top: 25px;
    }

    .margin-bottom-0 {
        margin-bottom: 0 !important;
    }

    .margin-bottom-5 {
      margin-bottom: 5px !important;
    }

    .margin-bottom-10 {
        margin-bottom: 10px !important;
    }

    .margin-bottom-12 {
        margin-bottom: 12px !important;
    }

    .margin-bottom-20 {
        margin-bottom: 20px !important;
    }

    .p-12 {
      padding: 12px;
    }

    .p-t-12 {
        padding-top: 12px;
    }

    .p-y-10 {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .p-y-0 {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .p-x-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .p-x-15rem {
        padding-right: 1.5rem;
        padding-left: 1.5rem;
    }

    .padding-top-03em {
        padding-top: 0.3em;
    }

    .padding-10 {
        padding: 10px;
    }

    .padding-top-0 {
        padding-top: 0 !important;
    }

    .padding-bottom-0 {
        padding-bottom: 0!important;
    }

    .margin-right-8 {
        margin-right: 8px;
    }

    .color-2aabe1 {
        color: #2aabe1 !important;
    }

    .margin-left--5 {
      margin-left: -5px;
    }

    .margin-left-0 {
      margin-left: 0 !important;
    }

    .m-l-12 {
      margin-left: 12px !important;
    }

    .margin-left-20 {
        margin-left: 20px !important;
    }

    .margin-left-35 {
      margin-left: 35px !important;
    }

    .margin-right-50 {
        margin-right: 50px !important;
    }

    .padding-left-0 {
        padding-left: 0 !important;
    }

    .margin-top-0 {
        margin-top: 0 !important;
    }

    .margin-right-0 {
        margin-right: 0 !important;
    }

    .background-none {
        background: none !important;
    }

    .clear-floats {
        clear: both;
    }

    .padding-right-0 {
        padding-right: 0 !important;
    }

    input:focus {
        outline: none !important;
    }

    .pad70-desktop {
        padding-right: 70px;
    }

    .pad90-desktop {
        padding-right: 90px;
    }

    .pad35-desktop {
        padding-right: 35px;
    }

    @media screen and (max-width: 767px) {
        .pad70-desktop {
            padding-right: 40px;
        }
    }

    .is-padded-20 {
        padding: 20px;
    }

    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    .table td, .table th {
        border-bottom: 10px solid #fff !important;
        color: #58595b;
        vertical-align: middle;
        padding: 0.7rem 0.75em !important;
    }

    .eft-table td, .table th {
        border-bottom: 0 !important;
        padding: 0.4em 0.4em 0.4em 0 !important;
    }

    .table tbody td, .table tbody th {
        font-size: 10pt;
    }

    .circle-border {
        border-radius: 50% !important;
        height: 40px;
        background-color: #30AAE1;
    }

    .red {
        color: #f05645;
    }

    .yellow {
        color: #fbbb4e;
    }

    .orange {
        color: #f89b58;
    }

    .green {
        color: #25b888;
    }

    .light-green {
        color: #60c3a7;
    }

    .grey {
        color: #abacac;
    }

    .asd__day-button {
        font-size: 12px;
    }

    .asd__wrapper--full-screen {
        z-index:99;
    }

    .asd__mobile-close {
        font-size: 20px;
        background: none;
    }

    .asd__month {
        padding:15px 15px 10px 15px;
    }

    .asd__mobile-header h3 {
        font-size:1em;
        font-weight: bold;
    }

    .airbnb-datepicker-trigger {
        width: 100%;
        padding: 10px;
        color: #8a8c91;
        font-size: 0.75rem;
        font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
        border: 1px solid #dbdbdb;
    }

    .asd__wrapper--datepicker-open {
        right: 0 !important;
    }

    .asd__action-buttons button:hover {
        text-decoration: none !important;
    }

    .asd__action-buttons button, .asd__day--enabled:focus {
        outline:none!important;
    }

    .asd__month-name {
        font-size: 1em;
        text-align: center;
        margin: 0 0 30px;
        line-height: 2.1em;
        font-weight: 700;
    }

    .asd__action-buttons {
        padding-top: 0;
        margin-bottom: 0;
    }

    .asd__action-buttons button{
        font-size: 13px;
    }

    ::placeholder {
        color: rgba(54, 54, 54, 0.3);
        opacity: 1;
    }

    .is-fullwidth-mobile {
        display: flex;
        width: 100%;
    }

    .padding-bottom-10 {
        padding-bottom: 10px;
    }

    .has-word-wrapped {
        word-wrap: break-word;
    }

    .has-width-auto {
        width: auto !important;
    }

    .margin-bottom-9rem {
        margin-bottom: 9rem;
    }

    .margin-top-2rem {
        margin-top: 2rem;
    }

    .margin-2rem {
        margin: 2rem;
    }

    div.brown_div_cont {
        background-color: #f5f5f5;
    }

    .brown_div_cont {
        margin-bottom: 22px;
    }

    .has-text-underlined {
        text-decoration: underline !important;
        color: #363636;
    }

    .is-display-block {
        display: block !important;
    }

    .card-header > p {
        color: #ffffff;
    }

    .mobile-anchor-button-tick-padding {
        padding: 10px 13px 10px 13px!important;
    }

    .card-header {
        background-color: #909ea9;
        min-height: 63px;
    }

    .card {
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 0 rgba(10, 10, 10, 0.1);
        margin-bottom: 20px;
    }

    .card-header.is-hidden-tablet {
        display: block;
        padding-bottom: 0.75rem;
    }

    .card-header.is-hidden-tablet > .is-fullwidth {
        margin-left: 0.75rem;
        margin-right: 0.75rem;
    }

    .is-display-contents {
        display: contents;
    }

    span.info-display {
        display: block;
        margin-bottom: 5px;
    }

    input[type="radio"] {
        /* remove standard background appearance */
        -webkit-appearance: none;
        -moz-appearance: none;
        /* create custom radiobutton appearance */
        display: inline-block;
        width: 18px;
        height: 18px;
        padding: 3px;
        /* background-color only for content */
        background-clip: content-box;
        border: 1px solid #d5d3d3;
        background-color: #fff;
        border-radius: 50%;
        vertical-align: middle;
    }

    /* appearance for checked radiobutton */
    input[type="radio"]:checked {
        background-color: #30AAE1;
        border: 1px solid #30AAE1;
    }

    .is-background-f5f5f5 {
        background: #f5f5f5!important;
    }

    .file-label-mobile {
        display: block !important;
        width: 100% !important;
        text-align: center !important;
    }

    .file-mobile {
        width: 100% !important;
    }

    .min-width-200 {
        min-width: 200px;
    }

    .button-width-150px {
        min-width: 150px!important;
    }

    .button-width-200px {
        min-width: 200px!important;
    }

</style>
<style lang="scss">
    /*** COLOR PALETTE **/
    $color-31AAE1: #31AAE1;
    $color-288FBE: #288FBE;
    $color-58595B: #58595B;
    $color-FFFFFF: #FFFFFF;
    $color-444A50: #444A50;
    $color-CDCBCB: #CDCBCB;
    $color-9DCCE1: #9DCCE1;
    $color-3056E1: #3056E1;
    $color-8a8c91: #8a8c91;
    $color-1261A0: #1261A0;

    /*** BUTTON FONT SIZES CONFIGS ***/
    $default-button-font-size: 0.75rem;
    $default-button-font-size-small: 0.75rem;
    $default-button-font-size-medium: 0.8rem;
    $default-button-font-size-large: 0.75rem;
    $default-button-font-size-large-public: 0.9rem;
    $default-button-font-size-xlarge: 0.9rem;
    $default-button-large-padding-right: 3.75em;
    $default-button-large-padding-left: 3.75em;
    $default-button-small-padding-left: 1.3rem;
    $default-button-small-padding-right: 1.3rem;
    $default-button-medium-padding-left: 2.75rem;
    $default-button-medium-padding-right: 2.75rem;
    $default-button-large-height: 3.25em;
    $default-button-small-height: 2.75em;

    /*** BUTTON SIZES CONFIGS ***/
    $default-button-padding: 10px 20px 10px 20px;
    $default-button-small-width-size: 48%;
    $default-button-medium-width-size: 35%;
    $default-button-large-width-size: 48%;
    $default-button-xlarge-width-size: 26%;
    $default-button-search-width-size: 48%;

    /*** BLUE BUTTON COLOR CONFIGS ***/
    $button-blue-bg-color: $color-31AAE1;
    $button-blue-font-color: $color-FFFFFF;
    $button-blue-border-color: $color-31AAE1;

    /** Dark blue button colors **/
    $button-dark-blue-bg-color: $color-1261A0;
    $button-dark-blue-font-color: $color-FFFFFF;
    $button-dark-blue-border-color: $color-1261A0;

    $button-white-bg-color: $color-FFFFFF;
    $button-white-font-color: $color-31AAE1;
    $button-white-border-color: $color-FFFFFF;

    $button-blue-hover-bg-color: $color-288FBE;
    $button-blue-hover-font-color: $color-FFFFFF;
    $button-blue-hover-border-color: $color-288FBE;

    $button-blue-outline-bg-color: $color-FFFFFF;
    $button-blue-outline-font-color: $color-31AAE1;
    $button-blue-outline-border-color: $color-31AAE1;

    /** Dark Blue outlines button */
    $button-dark-blue-outline-bg-color: $color-FFFFFF;
    $button-dark-blue-outline-font-color:  $color-1261A0;
    $button-dark-blue-outline-border-color:  $color-1261A0;

    $button-white-outline-bg-color: transparent;
    $button-white-outline-font-color: $color-FFFFFF;
    $button-white-outline-border-color: $color-FFFFFF;

    $button-blue-outline-hover-bg-color: $color-FFFFFF;
    $button-blue-outline-hover-font-color: $color-288FBE;
    $button-blue-outline-hover-border-color: $color-288FBE;

    /*** GREY BUTTON COLOR CONFIGS ***/
    $button-grey-bg-color: $color-58595B;
    $button-grey-font-color: $color-FFFFFF;
    $button-grey-border-color: $color-58595B;

    $button-grey-hover-bg-color: $color-444A50;
    $button-grey-hover-font-color: $color-FFFFFF;
    $button-grey-hover-border-color: $color-444A50;

    $button-grey-outline-bg-color: $color-FFFFFF;
    $button-grey-outline-font-color: $color-58595B;
    $button-grey-outline-border-color: $color-58595B;

    $button-grey-outline-hover-bg-color: $color-FFFFFF;
    $button-grey-outline-hover-font-color: $color-444A50;
    $button-grey-outline-hover-border-color: $color-444A50;

    $button-outline-disabled-font-color: $color-CDCBCB;
    $button-outline-disabled-border-color: $color-CDCBCB;
    $button-outline-disabled-bg-color: $color-FFFFFF;

    /** DISABLED BUTTONS COLOR CONFIG **/
    $button-disabled-font-color: $color-FFFFFF;
    $button-disabled-border-color: $color-CDCBCB;
    $button-disabled-bg-color: $color-CDCBCB;

    /** ANCHOR LINKS **/
    $achor-grey: $color-58595B;

    .button {
        font-size: $default-button-font-size;
        padding: $default-button-padding;
        line-height: normal;
        height: auto;
        border-radius: 0;

        &:active,
        &:focus:not(:active),
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
        }
    }

    /** file upload button **/
    .file-cta {
        font-size: $default-button-font-size;
        padding: $default-button-padding;
        line-height: normal;
        height: auto;
        border-radius: 0;

        color: $button-grey-font-color;
        background-color: $button-grey-bg-color;
        border-color: $button-grey-border-color;

        &:hover {
            color: $button-grey-hover-font-color !important;
            background-color: $button-grey-hover-bg-color !important;
            border-color: $button-grey-hover-border-color !important;
        }
    }

    /*** DISTINCT BUTTONS. SHOULD BE USED AS STANDALONE - NO NEED TO ADD BUTTON AS PART OF A CLASS LIST **/
    .button-nav {
        height: 2.25em;
        font-size: 0.9rem;
        margin-top: 0.6rem;

        &:active,
        &:focus:not(:active),
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
        }
    }

    .button-search {
        border-left: 0;
        border-right: 1px solid $color-8a8c91 !important;
        border-bottom: 1px solid $color-8a8c91 !important;
        border-top: 1px solid $color-8a8c91 !important;
        padding-top: calc(0.375em - 1px);
        padding-bottom: calc(0.375em - 1px);
        cursor: pointer !important;
        font-size: 1rem;
        color: $button-blue-font-color;
        background-color: $button-blue-bg-color;

        &:active,
        &:focus,
        &:focus:not(:active),
        &:hover,
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
            border-right: 1px solid $color-8a8c91 !important;
            border-bottom: 1px solid $color-8a8c91 !important;
            border-top: 1px solid $color-8a8c91 !important;
            background-color: $button-blue-hover-bg-color !important;
            color: $button-blue-hover-font-color !important;
        }
    }

    .button-mobile {
        font-size: 1rem;
        padding-top: calc(0.375em - 1px);
        padding-bottom: calc(0.375em - 1px);
        padding-left: 0.75em;
        padding-right: 0.75em;
        line-height: normal;

        &:active,
        &:focus:not(:active),
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
        }
    }

    .button-edit {
        font-size: 1rem;
        padding-top: calc(0.375em - 1px);
        padding-bottom: calc(0.375em - 1px);
        padding-left: 0.75em;
        padding-right: 0.75em;
        line-height: normal;
        position: relative;
        color: $color-31AAE1 !important;

        &:active,
        &:focus:not(:active),
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .button-mobile-table {
        padding: 8px 12px 10px 12px;
        line-height: normal;

        &:active,
        &:focus:not(:active),
        is-focused:not(:active) {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
            outline: 0 !important;
        }
    }

    @media screen and (min-width: 1023px) {
        .button-nav {
            &:last-child {
                margin-right: 50px;
                margin-left: 20px;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .button-nav {
            display: flex;
            width: 100%;

            &:last-child {
                margin-right: 0;
                margin-left: 0;
            }
        }
    }

    /** rules to describe hp variant button appearances **/
    .is-button-xlarge {
        font-size: $default-button-font-size-xlarge !important;
        padding-left: $default-button-large-padding-left;
        padding-right: $default-button-large-padding-right;
        height: $default-button-large-height;
    }

    .is-button-large {
        font-size: $default-button-font-size-large !important;
        min-width: $default-button-large-width-size;
        max-width: $default-button-large-width-size;
        display: inline-flex;

        &-with-no-min-max-width {
            min-width: auto !important;
            max-width: none !important;
            font-size: $default-button-font-size-large !important;
        }

        &-public {
            font-size: $default-button-font-size-large-public !important;
            min-width: $default-button-large-width-size !important;
            max-width: $default-button-large-width-size !important;
        }
    }

    .is-button-medium {
        font-size: $default-button-font-size-medium !important;
        padding-left: $default-button-medium-padding-left;
        padding-right: $default-button-medium-padding-left;
        display: inline-flex;
    }

    .is-button-small {
        font-size: $default-button-font-size-small !important;
        padding-left: $default-button-small-padding-left;
        padding-right: $default-button-small-padding-right;
        display: inline-flex;
    }

    /** rules to describe button appearances in terms of colour **/
    .is-button-blue {
        color: $button-blue-font-color;
        background-color: $button-blue-bg-color!important;
        border-color: $button-blue-border-color;

        &:hover {
            color: $button-blue-hover-font-color !important;
            background-color: $button-blue-hover-bg-color !important;
            border-color: $button-blue-hover-border-color !important;
        }

        &:active,
        &:focus {
            color: $button-blue-font-color;
            background-color: $button-blue-bg-color;
            border-color: $button-blue-border-color;
        }
    }
    /** rules for dark blue color **/
    .is-button-dark-blue {
      color: $button-dark-blue-font-color;
      background-color: $button-dark-blue-bg-color !important;
      border-color: $button-dark-blue-border-color;

      &:hover,
      &:active,
      &:focus {
        color: $button-dark-blue-font-color !important;
        background-color: $button-dark-blue-bg-color !important;
        border-color: $button-dark-blue-border-color !important;
      }
    }

    .is-button-white {
        color: $button-white-font-color;
        background-color: $button-white-bg-color;
        border-color: $button-white-border-color;

        &:hover,
        &:active,
        &:focus {
            color: $button-white-font-color;
            background-color: $button-white-bg-color;
            border-color: $button-white-border-color;
        }
    }

    .is-button-grey {
        color: $button-grey-font-color;
        background-color: $button-grey-bg-color;
        border-color: $button-grey-border-color;

        &:hover,
        &:active,
        &:focus {
            color: $button-grey-hover-font-color;
            background-color: $button-grey-hover-bg-color;
            border-color: $button-grey-hover-border-color;
        }
    }

    .is-button-blue-outline {
        color: $button-blue-outline-font-color;
        background-color: $button-blue-outline-bg-color;
        border-color: $button-blue-outline-border-color;

        &:hover,
        &:active,
        &:focus {
            color: $button-blue-outline-hover-font-color !important;
            background-color: $button-blue-outline-hover-bg-color !important;
            border-color: $button-blue-outline-hover-border-color !important;
        }
    }

    .is-button-dark-blue-outline {
      color: $button-dark-blue-outline-font-color;
      background-color: $button-dark-blue-outline-bg-color;
      border-color: $button-dark-blue-outline-border-color;

      &:hover,
      &:active,
      &:focus {
        color: $button-dark-blue-outline-font-color !important;
        background-color: $button-dark-blue-outline-bg-color !important;
        border-color: $button-dark-blue-outline-border-color !important;
      }
    }

    .is-button-white-outline {
        color: $button-white-outline-font-color;
        background-color: $button-white-outline-bg-color;
        border-color: $button-white-outline-border-color;

        &:hover,
        &:active,
        &:focus {
            color: $button-white-outline-font-color !important;
            background-color: $button-white-outline-bg-color !important;
            border-color: $button-white-outline-border-color !important;
        }
    }

    .is-button-grey-outline {
        color: $button-grey-outline-font-color;
        background-color: $button-grey-outline-bg-color;
        border-color: $button-grey-outline-border-color;

        &:hover,
        &:active,
        &:focus {
            color: $button-grey-outline-hover-font-color !important;
            background-color: $button-grey-outline-hover-bg-color !important;
            border-color: $button-grey-outline-hover-border-color !important;
        }
    }

    .is-button-outline-disabled {
        color: $button-outline-disabled-font-color !important;
        background-color: $button-outline-disabled-bg-color !important;
        border-color: $button-outline-disabled-border-color !important;

        &:hover,
        &:active,
        &:focus {
            color: $button-outline-disabled-font-color !important;
            background-color: $button-outline-disabled-bg-color;
            border-color: $button-outline-disabled-border-color !important;
        }
    }

    .is-button-disabled,
    .is-button-blue[disabled],
    .is-button-grey[disabled] {
        color: $button-disabled-font-color !important;
        background-color: $button-disabled-bg-color !important;
        border-color: $button-disabled-border-color !important;

        &:hover,
        &:active,
        &:focus {
            color: $button-disabled-font-color !important;
            background-color: $button-disabled-bg-color !important;
            border-color: $button-disabled-border-color !important;
        }
    }

    .has-button-medium-min-max-width {
        min-width: $default-button-medium-width-size;
        max-width: $default-button-medium-width-size;
    }

    a.achor-grey {
        color: $achor-grey;

        &:hover,
        &:active,
        &:focus {
            color: $achor-grey;
        }
    }

    .is-color-3056E1 {
        color: $color-3056E1;

        &:hover {
            color: $color-3056E1;
        }
    }

    .is-color-31AAE1 {
        color: $color-31AAE1;

        &:hover {
            color: $color-288FBE;
        }
    }

    .circle-border-edit {
        font-size: 10px !important;
        background-color: #565e65 !important;
        border: none;
        height: auto !important;

        &:hover {
            cursor: pointer;
        }
    }
    .nps-red {
        color: red;
    }
    .nps-orange {
        color: orange;
    }
    .nps-green {
        color: green;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue